import * as i0 from '@angular/core';
import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

class BadgeComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: BadgeComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.1.3", type: BadgeComponent, isStandalone: true, selector: "wb-ui-badge", inputs: { status: "status" }, ngImport: i0, template: "<span\n  class=\"p1 text-center px-4 d-inline-flex rounded-7\"\n  [ngClass]=\"('badge-' + status)\"\n>\n  <ng-content></ng-content>\n</span>\n", styles: [""], dependencies: [{ kind: "directive", type: NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: BadgeComponent, decorators: [{
            type: Component,
            args: [{ standalone: true, selector: 'wb-ui-badge', imports: [NgClass], template: "<span\n  class=\"p1 text-center px-4 d-inline-flex rounded-7\"\n  [ngClass]=\"('badge-' + status)\"\n>\n  <ng-content></ng-content>\n</span>\n" }]
        }], propDecorators: { status: [{
                type: Input
            }] } });

var BadgeStatus;
(function (BadgeStatus) {
    BadgeStatus["ACCENTS_PRIMARY"] = "accents-primary";
    BadgeStatus["ACCENTS_SECONDARY"] = "accents-secondary";
    BadgeStatus["ACCENTS_SECONDARY_400"] = "accents-secondary-400";
    BadgeStatus["DONE"] = "done";
    BadgeStatus["ERROR"] = "error";
    BadgeStatus["SUCCESS"] = "success";
    BadgeStatus["GRAY"] = "gray";
})(BadgeStatus || (BadgeStatus = {}));

/**
 * Generated bundle index. Do not edit.
 */

export { BadgeComponent, BadgeStatus };
